import {useNavigate} from "react-router-dom";
import {AppContext} from "../../lib/AppContext";
import React, {useContext, useEffect, useRef, useState} from "react";
import {
  deleteAccountType,
  deleteInventory,
  getAccountTypes,
  getInventoryEventTypes,
  getInventoryMemberships,
  getInventoryTypes,
  saveAccountType,
  saveInventory,
  saveInventoryMembership
} from "../common/api/InventoryApi";
import {Button, ButtonGroup, Card, CardContent, Chip, FormControl, Select} from "@mui/material";
import Meta from "../common/Meta";
import Confirm from "../common/Confirm";
import ContextSearchNavbar from "../navbars/ContextSearchNavbar";
import DashboardLayout from "../LayoutContainers/DashboardLayout";
import MDBox from "../../components/MDBox";

import Footer from "../Footer";
import Grid from "@mui/material/Grid";
import ManageAccountTypeModal from "./ManageAccountTypeModal";
import ManageInventoryMembershipModal from "./ManageInventoryMembershipModal";
import NotificationItem from "../Items/NotificationItem";
import Icon from "@mui/material/Icon";
import Menu from "@mui/material/Menu";
import Avatar from "@mui/material/Avatar";
import MDButton from "../../components/MDButton";
import MenuItem from "@mui/material/MenuItem";
import {People, PercentRounded} from "@mui/icons-material";
import {formatCurrency, portalViewUrl, truncDetail} from "../common/Utils";
import PopupState, {bindMenu, bindTrigger} from "material-ui-popup-state";
import FileSelector from "../calendarUI/FilterSelector";
import {CONSTANTS} from "../common/constants";
import Checkbox from "@mui/material/Checkbox";
import {CompanyContext} from "../../lib/CompanyContext";

export default function Membership(props) {

  const navigate = useNavigate();
  const [context, setContext] = useContext(AppContext);
  const [renderIndex, setRenderIndex] = useState(1);
  const [company, setCompany] = useState();
  const [companyContext, setCompanyContext] = useContext(CompanyContext);

  useEffect(() => {
    setCompany(companyContext?.company)
  }, [companyContext]);

  const myRefs = useRef([]);

  const refHandler = (index) => {
    myRefs.current[index].visible = !!!myRefs.current[index].visible;
    setRenderIndex(renderIndex + 1);
  };

  const [inventoryTypes, setInventoryTypes] = useState([]);
  const [accountTypes, setAccountTypes] = useState([]);
  const [inventoryEventTypes, setInventoryEventTypes] = useState([]);
  const [inventoryType, setInventoryType] = useState(null);
  const [accountType, setAccountType] = useState(null);

  const [renderDate, setRenderDate] = useState(new Date().getTime());

  const [saving, setSaving] = useState(false);
  const [manageAccountType, setManageAccountType] = useState(false);

  const [manageInventory, setManageInventory] = useState(false);
  const [isInventoryEvent, setIsInventoryEvent] = useState(false);
  const [inventory, setInventory] = useState(null);
  const [inventories, setInventories] = useState(null);
  const [sortInventory, setSortInventory] = useState({field: 'name', direction: 'asc'});

  const [confirmation, setConfirmation] = useState(null);
  const [confirmDelete, setConfirmDelete] = useState(false);

  const [accountTypeFilter, setAccountTypeFilter] = useState([]);
  const [statusTypeFilter, setStatusTypeFilter] = useState([]);

  const statuses = [...CONSTANTS.STATUSES];

  const showMembershipFilter = (membership) => {
    if (!accountTypeFilter.length) {
      return true;
    }
    for (const j in accountTypeFilter) {
      if (membership?.accountType?.id === accountTypeFilter[j]) {
        return true;
      }
    }
    return false;
  }

  const showStatusTypeFilter = (membership) => {
    if (!statusTypeFilter.length) {
      return true;
    }
    for (const j in statusTypeFilter) {
      if (membership?.status?.id === statusTypeFilter[j]) {
        return true;
      }
    }
    return false;
  }

  const membershipsFilter = (membership) => {
    let show = showMembershipFilter(membership);
    show = show && showStatusTypeFilter(membership);
    return show;
  }

  const [recurrenceTypes, setRecurrenceTypes] = useState([
    {
      sortOrder: -1,
      id: 'ALL',
      name: 'All'
    },
    {
      sortOrder: 1,
      id: 'NONE',
      name: 'None'
    },
    {
      sortOrder: 2,
      id: 'TIME_BASED',
      name: 'Time Based'
    },
    ,
    {
      sortOrder: 3,
      id: 'MONTHLY',
      name: 'Renews Monthly'
    },
    {
      sortOrder: 4,
      id: 'ANNUALLY',
      name: 'Renews Annually'
    }]);

  const [recurrenceTypeFilter, setRecurrenceTypeFilter] = useState('ALL');
  const [isShowFamilyPass, setIsShowFamilyPass] = useState(false);
  const [isShowUnlimited, setIsShowUnlimited] = useState(false);
  const [isShowDecremented, setIsShowDecremented] = useState(false);

  const showAccountType = (accountType) => {
    if (recurrenceTypeFilter === 'ALL') {
      return true;
    } else if (recurrenceTypeFilter === 'NONE' && !accountType.recurrencePattern) {
      return true;
    }
    return accountType.recurrencePattern === recurrenceTypeFilter;
  }

  const showFamilyPass = (accountType) => {
    if (!isShowFamilyPass) {
      return true;
    }
    return accountType?.familyPass;
  }

  const showDecremented = (accountType) => {
    if (!isShowDecremented) {
      return true;
    }
    return !accountType?.unlimitedVisits;
  }

  const showUnlimited = (accountType) => {
    if (!isShowUnlimited) {
      return true;
    }
    return accountType?.unlimitedVisits;
  }


  const filterAccountTypes = (accountType) => {
    let show = showAccountType(accountType);
    show = show && showFamilyPass(accountType);
    show = show && showUnlimited(accountType);
    show = show && showDecremented(accountType);

    return show;
  }

  const confirmDeleteInventory = (inventory) => {
    let confirmation = {
      title: 'Delete ' + inventory.name + '?',
      message: 'Delete ' + inventory.name + ' Permanently?',
      entity: inventory
    }
    setConfirmation(confirmation);
    setConfirmDelete(true);
  }

  const editAccountType = (accountType) => {
    handleCloseInventory();
    for (let j in accountTypes) {
      if (accountTypes[j].id === accountType.id) {
        manageAccountTypeFn(accountTypes[j]);
        return;
      }
    }
  }

  const handleDeleteInventory = async (inventory) => {
    let result = await deleteInventory(inventory.guid);
    if (result.error) {
      setContext({...context, error: {message: result.message}});
    } else {
      setConfirmDelete(false);
      loadMembershipInventoryFn();
    }
  }

  const handleCloseDeleteInventory = async () => {
    setConfirmDelete(false);
  };

  const loadInventoryTypes = () => {
    getInventoryTypes().then(result => {
      if (result.error) {
        setContext({...context, error: {message: result.message}});
      } else {
        setInventoryTypes(result);
      }
    });
  }

  const loadAccountTypes = () => {
    getAccountTypes().then(result => {
      if (result.error) {
        setContext({...context, error: {message: result.message}});
      } else {
        setAccountTypes(result);
      }
    });
  }

  const loadInventoryEventTypes = () => {
    getInventoryEventTypes().then(result => {
      if (result.error) {
        setContext({...context, error: {message: result.message}});
      } else {
        setInventoryEventTypes(result);
      }
    });
  }


  const loadMembershipInventoryFn = () => {
    getInventoryMemberships().then(result => {
      if (result.error) {
        setContext({...context, error: {message: result.message}});
      } else {
        setRenderDate(new Date().getTime());
        setInventories(result);
      }
    });
  }

  const saveAccountTypeFn = async (accountType) => {
    let result = await saveAccountType(accountType);
    if (result.error) {
      setContext({...context, error: {message: result.message}});
    } else {
      closeAccountTypeFn();
      loadAccountTypes();
      loadMembershipInventoryFn();
    }
  }

  const saveInventoryFn = async (inventory) => {
    let result = await saveInventory(inventory);
    if (result.error) {
      setContext({...context, error: {message: result.message}});
    } else {
      closeInventoryFn();
      loadInventoryTypes();
    }
  }

  const handleSaveInventory = async (inventory) => {
    const inv = {...inventory};
    inv.inventoryEvent = isInventoryEvent;
    let result = await saveInventoryMembership(inv);
    if (result.error) {
      setContext({...context, error: {message: result.message}});
    } else {
      closeInventoryFn();
      loadMembershipInventoryFn();
    }
  }

  const handleCloseInventory = () => {
    setManageInventory(false);
  }

  useEffect(() => {
    loadMembershipInventoryFn();
    loadAccountTypes();
  }, []);

  const addAccountTypeFn = () => {
    setAccountType(null);
    setManageAccountType(true);
  }

  const manageAccountTypeFn = (accountType) => {
    let t = null;
    if (accountType) {
      t = {...accountType};
    }
    t.recurrencePattern = t.recurrencePattern + '';
    setAccountType(t);
    setManageAccountType(true);
  }

  const addInventoryFn = () => {
    setInventory(null);
    setIsInventoryEvent(false);
    setManageInventory(true);
  }

  const addInventoryEventFn = () => {
    setInventory(null);
    setIsInventoryEvent(true);
    setManageInventory(true);
  }

  const manageInventoryFn = (inventory) => {
    let t = null;
    if (inventory) {
      t = {...inventory};
    }
    setIsInventoryEvent(false);
    setInventory(t);
    setManageInventory(true);
  }

  const manageInventoryEventFn = (inventory) => {
    let t = null;
    if (inventory) {
      t = {...inventory};
    }
    setIsInventoryEvent(true);
    setInventory(t);
    setManageInventory(true);
  }

  const closeAccountTypeFn = () => {
    setAccountType(null);
    setManageAccountType(false);
  }
  const closeInventoryFn = () => {
    setInventory(null);
    setManageInventory(false);
  }

  const sortInventoryFn = (a, b) => {
    const sortDir = sortInventory.direction === 'asc' ? 1 : -1;
    if (sortInventory.field === 'name') {
      return a.name.toUpperCase() > b.name.toUpperCase() ? sortDir : sortDir * -1;
    }
    if (sortInventory.field === 'createDate') {
      return new Date(a.createDate).getTime() > new Date(b.createDate).getTime() ? sortDir : sortDir * -1;
    }
    if (sortInventory.field === 'modifyDate') {
      return new Date(a.modifyDate).getTime() > new Date(b.modifyDate).getTime() ? sortDir : sortDir * -1;
    }
    return a.id > b.id ? sortDir : sortDir * -1;
  }

  const [confirmDeleteAccountType, setConfirmDeleteAccountType] = useState(false);

  const handleArchiveAccountType = async (inventory) => {
    let result = await deleteAccountType(inventory.guid);
    if (result.error) {
      setContext({...context, error: {message: result.message}});
    } else {
      setConfirmDeleteAccountType(false);
      loadAccountTypes();
    }
  }
  const handleCloseAccountType = () => {
    setConfirmDeleteAccountType(false);
  };
  const confirmDeleteAccountTypeFn = (inventory) => {
    let confirmation = {
      title: 'Archive ' + inventory.name + '?',
      message: 'Confirm archive ' + inventory.name + '?',
      entity: inventory
    }
    setConfirmation(confirmation);
    setConfirmDeleteAccountType(true);
  }

  const AccountTypeActions = ({item}) => {
    return (<PopupState variant="popover" popupId={'inventory-popup-menu-' + item.id}>
      {(popupState) => (
        <>
          <MDButton {...bindTrigger(popupState)}
                    variant="outlined"
                    color="secondary"
                    size="small"
                    circular
                    iconOnly
          >
            <Icon>more_horiz</Icon>
          </MDButton>
          <Menu {...bindMenu(popupState)}>
            <NotificationItem
              onClick={(e) => {
                popupState.close();
                manageAccountTypeFn(item)
              }} icon={<Icon>edit</Icon>} title="Edit"/>
            <NotificationItem onClick={(e) => {
              popupState.close();
              confirmDeleteAccountTypeFn(item)
            }} icon={<Icon>delete</Icon>} title="Archive"/>
          </Menu>
        </>
      )}
    </PopupState>);
  }

  return (
    <DashboardLayout>

      <Meta pageTitle={'Inventory - Memberships'}/>

      <ContextSearchNavbar title="Inventory Memberships"/>
      <MDBox py={3}>
        <MDBox mb={3}>

          <Grid container spacing={2}>
            <Grid item xs={12} sm={5}>
              <Card mt={2}>
                <MDBox p={2}>
                  <h5>
                    Account Types
                    <MDButton
                      color="secondary"
                      size="small"
                      className={'pull-right'}
                      onClick={(e) => {
                        addAccountTypeFn();
                      }}>
                      Add
                    </MDButton>
                  </h5>

                  <div className={'d-block'}>
                    <ButtonGroup className={'my-2 pull-right'}
                                 variant="outlined"
                                 size="small"
                                 aria-label="Filter Account Types">

                      {recurrenceTypes?.sort((r1, r2) => r1.sortOrder - r2.sortOrder).map((rt) => {
                        return (
                          <Button
                            size="small"
                            key={rt.id}
                            style={{
                              color: recurrenceTypeFilter === rt.id ? '#fff' : '#111',
                              background: recurrenceTypeFilter === rt.id ? '#111' : '#fff',
                              borderColor: '#111'
                            }}
                            onClick={(e) => {
                              setRecurrenceTypeFilter(rt.id)
                            }}>
                            {rt.name}
                          </Button>
                        )
                      })}
                    </ButtonGroup>
                  </div>

                  <Grid container>
                    <Grid item xs={12} sm={4}>
                      <label>
                        <Checkbox
                          checked={isShowFamilyPass}
                          onChange={(e) => {
                            setIsShowFamilyPass(!isShowFamilyPass)
                          }}
                        />
                        Family Pass
                      </label>
                    </Grid>

                    <Grid item xs={12} sm={4}>
                      <label>
                        <Checkbox
                          checked={isShowUnlimited}
                          onChange={(e) => {
                            if (e.target.checked) {
                              setIsShowDecremented(false);
                            }
                            setIsShowUnlimited(!isShowUnlimited)
                          }}
                        />
                        Unlimited
                      </label>
                    </Grid>

                    <Grid item xs={12} sm={4}>
                      <label>
                        <Checkbox
                          checked={isShowDecremented}
                          onChange={(e) => {
                            if (e.target.checked) {
                              setIsShowUnlimited(false);
                            }
                            setIsShowDecremented(!isShowDecremented)
                          }}
                        />
                        Decremented
                      </label>
                    </Grid>

                  </Grid>

                  <div className={'d-block'} style={{
                    display: 'block',
                    clear: 'both',
                    marginTop: '6px'
                  }}>

                    <ul className={'list-group'}>

                      {accountTypes && accountTypes?.length > accountTypes.filter(filterAccountTypes).length && <li
                        className={'list-group-item '} style={{
                        background: '#efefef'
                      }}>
                        <center>Showing {accountTypes.filter(filterAccountTypes).length} ({accountTypes?.length - accountTypes.filter(filterAccountTypes).length + ' Filtered'})</center>
                      </li>
                      }

                      {accountTypes.filter(filterAccountTypes).map((type, index) => {
                        return (
                          <li
                            className={'list-group-item '}
                            key={index}>
                            {type.id <= -1 && type.name}
                            {type.id > -1 && type.name &&
                              <>
                            <span className="d-block pull-right">
                                    <AccountTypeActions item={type}/>
                                  </span>

                                <a
                                  href={'#'}
                                  onClick={(e) => {
                                    e.preventDefault();
                                    manageAccountTypeFn(type);
                                  }}>{type.name}</a>

                              </>
                            }
                            <span style={{display: 'block'}}>
                            {type.desc && <>
                              <small className={'text-small my-n2'} style={{
                                whiteSpace: 'pre-wrap',
                              }}>{type.desc}</small>
                            </>}
                          </span>
                            {type?.familyPass &&
                              <Chip variant="outlined"
                                    style={{
                                      marginRight: '4px'
                                    }}
                                    color="secondary" label="Family Pass"/>}
                            {type?.siblingDiscount > 0 &&
                              <Chip variant="outlined"
                                    style={{
                                      marginRight: '4px'
                                    }}
                                    color="secondary"
                                    label={'Sibling Discount: ' + formatCurrency(type.siblingDiscount)}/>}

                            {type?.unlimitedVisits &&
                              <Chip variant="outlined"
                                    style={{
                                      marginRight: '4px'
                                    }}
                                    color="secondary" label={'Unlimited Visits'}/>}

                            {type?.waiverGk > -1 &&
                              <Chip variant="outlined"
                                    style={{
                                      marginRight: '4px'
                                    }}
                                    color="secondary" label={'Waiver: ' + type.waiverName}/>}

                            {type?.notificationEmail && <Chip variant="outlined"
                                                                style={{
                                                                  marginRight: '4px'
                                                                }}
                                                                color="secondary" label={'Notifications: ' + type?.notificationEmail}/>}
                          </li>
                        );
                      })}
                    </ul>
                  </div>
                </MDBox>
              </Card>
            </Grid>

            <Grid item xs={12} sm={7}>
              <Card>

                <CardContent>

                  <div className={'row'}>
                    <div className={'col col-12'}>
                      <h5>
                        Memberships
                        <MDButton className={'pull-right'}
                                  color="info"
                                  size="small"
                                  onClick={(e) => {
                                    e.preventDefault();
                                    addInventoryFn();
                                  }}>
                          Add New
                        </MDButton>
                      </h5>
                    </div>


                    <Grid container spacing={1}>
                      <Grid item sm={6} xs={12}>
                        <FileSelector
                          width={'100%'}
                          types={accountTypes}
                          typeFilter={accountTypeFilter}
                          filterLabel={'Account Types'}
                          setFilter={(filters) => {
                            setAccountTypeFilter(filters);
                          }}
                        />
                      </Grid>

                      <Grid item sm={3} xs={12}>
                        <FileSelector
                          width={'100%'}
                          types={statuses.filter((t) => t.id !== 4)}
                          typeFilter={statusTypeFilter}
                          filterLabel={'Status'}
                          setFilter={(filters) => {
                            setStatusTypeFilter(filters);
                          }}
                        />
                      </Grid>

                      <Grid item sm={3} xs={12}>

                      </Grid>

                    </Grid>

                    <div className={'col col-12'}>
                      <div className={'meta-container my-2 d-block'}>
                        <div className={'d-block mb-2'}>
                          <span className={'d-inline p-1'}>Sort:</span>
                          <FormControl sx={{
                            width: 'auto'
                          }}>
                            <Select
                              autoWidth
                              sx={{
                                padding: '5px 10px',
                                marginRight: '5px'
                              }}
                              defaultValue={'name'}
                              onChange={
                                (e) => {
                                  setSortInventory({...sortInventory, field: e.target.value});
                                }
                              }>
                              <MenuItem value={'name'}>Name</MenuItem>
                              <MenuItem value={'createDate'}>Created On</MenuItem>
                              <MenuItem value={'modifyDate'}>Last Edited</MenuItem>
                            </Select>
                          </FormControl>
                          <FormControl sx={{
                            width: 'auto'
                          }}>
                            <Select
                              autoWidth
                              sx={{
                                padding: '5px 10px',
                                marginRight: '5px'
                              }}
                              defaultValue={'asc'}
                              onChange={
                                (e) => {
                                  setSortInventory({...sortInventory, direction: e.target.value});
                                }
                              }>
                              <MenuItem value={'asc'}>Asc</MenuItem>
                              <MenuItem value={'desc'}>Desc</MenuItem>
                            </Select>
                          </FormControl>
                        </div>

                      </div>

                    </div>
                  </div>
                  <ul className={'list-group'}>

                    {inventories && inventories?.length > inventories.filter(membershipsFilter).length && <li
                      className={'list-group-item '} style={{
                      background: '#efefef'
                    }}>
                      <center>Showing {inventories.filter(membershipsFilter).length} ({inventories?.length - inventories.filter(membershipsFilter).length + ' Filtered'})</center>
                    </li>
                    }

                    {inventories && inventories
                      .sort((a, b) => sortInventoryFn(a, b))
                      .filter(membershipsFilter)
                      .map((item, index) => {
                        return (
                          <div style={{
                            'position': 'relative'
                          }} className={'list-group-item'} key={index}>
                            <div className={'pull-right px-2'}
                                 onClick={(e) => {
                                   refHandler('item' + index)
                                 }}
                                 ref={el => (myRefs.current['item' + index] = el)}>
                              <MDButton
                                variant="outlined"
                                color="secondary"
                                size="small"
                                circular
                                iconOnly
                              >
                                <Icon>more_horiz</Icon>
                              </MDButton>
                              {renderIndex && myRefs.current['item' + index]?.visible &&
                                <Menu open={true} anchorReference={null} anchorEl={myRefs.current['item' + index]}
                                      anchorOrigin={{
                                        vertical: "bottom",
                                        horizontal: "left",
                                      }}>
                                  {companyContext?.company &&
                                    <NotificationItem
                                      href={portalViewUrl(companyContext?.company?.portalUrl) + 'view-item/' + item.guid}
                                      target={"_blank"}
                                      icon={<Icon>launch</Icon>} title="View in Portal"/>
                                  }
                                  <NotificationItem
                                    onClick={(e) => {
                                      manageInventoryFn(item)
                                    }} icon={<Icon>edit</Icon>} title="Edit"/>
                                  <NotificationItem onClick={(e) => {
                                    confirmDeleteInventory(item)
                                  }} icon={<Icon>delete</Icon>} title="Delete"/>
                                </Menu>
                              }
                            </div>
                            <a
                              href={'#'}
                              className={'link'}
                              onClick={(e) => {
                                e.preventDefault();
                                manageInventoryFn(item);
                              }}>&nbsp;{item.name} ({item.inventoryType?.name})</a>
                            <Avatar alt={item?.name}
                                    className={'pull-left mr-2'}
                                    sx={{width: 32, height: 32}}>
                              {item?.imageUrl && <img src={item?.imageThumbUrl || item?.imageUrl}
                                                      style={{width: '200%', height: 'auto'}}
                                                      alt={item?.name}/>}
                            </Avatar>
                            <div style={{
                              width:'100%',
                              clear:'both',
                              marginTop:'12px'
                            }} />
                            {item?.lockedAccount && <>
                              <Chip
                                className={'pull-left m-chip'}
                                icon={<Icon>lock</Icon>}
                                label={<>
                                  {(item?.numChildren > 0 || item?.numAdults > 0) && ' '}
                                  {item?.numChildren > 0 && (item.numChildren + ' Children ')} {item?.numAdults > 0 && (item.numAdults + ' Adults')}
                                </>}
                                variant="outlined"
                              />
                            </>}
                            {item?.minimumMembership && <>
                              <Chip
                                className={'pull-left m-chip'}
                                icon={<Icon>lock_clock</Icon>}
                                label={<>Mininum
                                  Contract {item?.minMembershipMonths} {item?.minMembershipMonths === 1 ? 'Month' : 'Months'}</>}
                                variant="outlined"
                              />
                            </>}

                            {item?.minimumCancellation && <>
                              <Chip
                                className={'pull-left m-chip'}
                                icon={<Icon>lock_person</Icon>}
                                label={<>{item?.minimumCancellationDays } {item?.minimumCancellationDays === 1 ? 'Day' : 'Days'} Cancellation Notice</>}
                                variant="outlined"
                              />
                            </>}

                            <Chip
                              className={'pull-left m-chip'}
                              label={item?.status?.name}
                              variant="outlined"
                            />
                            {item?.siblingMembership && <><Chip
                              icon={<People/>}
                              label={'Sibling Discount ' + formatCurrency(item?.siblingMembership?.discountAmount)}
                              variant="outlined"
                              deleteIcon={<PercentRounded/>}
                              color="secondary"/>
                            </>}
                            {item.desc && <small className={'d-block'} style={{
                              clear: 'both',
                              width: '100%',
                            }}>
                              {truncDetail(item.desc, 12)}
                            </small>}


                          </div>
                        )
                      })
                    }
                  </ul>
                </CardContent>
              </Card>
            </Grid>
          </Grid>

          {manageAccountType && <ManageAccountTypeModal
            accountType={accountType}
            show={manageAccountType}
            saving={saving}
            handleSave={saveAccountTypeFn}
            handleClose={closeAccountTypeFn}/>}

          {manageInventory && <ManageInventoryMembershipModal
            inventory={inventory}
            editAccountType={editAccountType}
            isInventoryEvent={isInventoryEvent}
            show={manageInventory}
            saving={saving}
            handleSave={handleSaveInventory}
            handleClose={handleCloseInventory}/>}

          {confirmDeleteAccountType && <Confirm confirmation={confirmation}
                                                show={confirmDeleteAccountType}
                                                saving={saving}
                                                handleConfirm={handleArchiveAccountType}
                                                handleSave={handleCloseAccountType}
                                                handleClose={handleCloseAccountType}/>}

          {confirmDelete && <Confirm confirmation={confirmation}
                                     show={confirmDelete}
                                     saving={saving}
                                     handleConfirm={handleDeleteInventory}
                                     handleSave={() => {
                                       setConfirmDelete(false);
                                     }}/>}
        </MDBox>
      </MDBox>

      <Footer mt={5}/>

    </DashboardLayout>
  );
}